import { UseFormSetValue, FieldValues } from 'react-hook-form';
import { BaseSlide } from '../../../../../models/slides/BaseSlide';
import { ProductSlide } from '../../../../../models/slides/ProductSlide';
import { fetchWinesForPreview } from '../../../../../services/wineServices/WinePreviewService';
import { getProductSlide } from './getProductSlide';

export const updateProduct = async ({ slide, setValue, index }: { slide: BaseSlide; setValue: UseFormSetValue<FieldValues>; index: number }) => {
  const wineSlide = slide as ProductSlide;
  if (!wineSlide.productVariantId) setValue(`slideDatas[${index}]`, emptyProduct);

  try {
    const wineElement = (await fetchWinesForPreview([wineSlide.productVariantId])) as ProductSlide[];
    const updatedWine = getProductSlide(wineElement);
    setValue(`slideDatas[${index}]`, updatedWine);
  } catch (error) {
    console.log(error);
  }
};

export const emptyProduct = {
  imgUrl: '',
  type: 'PRODUCT',
  description: '',
  title: '',
  id: 0,
  productVariantId: 0,
  availableQuantity: 0,
  basePrice: 0,
  discount: 0,
  currentPrice: 0,
  currentEurPrice: 0,
  baseEurPrice: 0,
  showEurPrice: false,
  isManufacturer: false,
  tags: [],
  productYear: 0,
};
